import { getAuthHeaders } from '../services/auth';

/** 素材工坊（生成任务产物下载）API 客户端。 */

/**
 * 下载生成产物 zip（blob 响应）。
 *
 * axios 实例默认按 JSON 解析响应，blob 走 fetch + getAuthHeaders 手动读取，
 * 行为与页面原内联实现一致（HTTP 错误拼接响应文本，由调用方 toast）。
 */
export async function downloadGeneratedArtifact(artifactId: string): Promise<Blob> {
  const res = await fetch(`/api/v1/generate/${artifactId}/download`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`下载失败 (HTTP ${res.status})${text ? `: ${text}` : ''}`);
  }
  return res.blob();
}
